import React, { useState } from "react";
import Section from "../sections/Section";
import { isValuePresent } from "../../utils/builderUtils";

const DEFAULT_CUSTOM_LOGO_URL =
  "https://uploads.convertflow.co/production/websites/417/xkLyrWoCSIWWDZQGlN9L_r7EfaBaSZWFE2F4WiA8w_brand-logo.png";
const DEFAULT_LIGHT_LOGO_URL =
  "https://uploads.convertflow.co/production/websites/417/Dage9SBxTSy85ePOKflw_brand-logo-white.png";

const normalizeUrl = (url) => {
  const value = url || "#";

  return /^(https?:|\/|#|mailto:|tel:)/i.test(value)
    ? value
    : `http://${value}`;
};

const ElementNavigation = (props) => {
  const website = props.website;
  let element = props.element;
  let variant = props.variant;
  const stylesheet = style.stylesheet(
    props.builder,
    props.device,
    props.cta,
    element,
    variant
  );

  const logoShow = element.options["nav-logo-show"] !== "false";

  // Fallback hierarchy: element → variant → website (same as the logo element)
  const logoFormat = element.options["logo-format"]
    ? element.options["logo-format"]
    : variant.options["logo-format"]
    ? variant.options["logo-format"]
    : "image";

  const logoStyle = element.options["logo-style"]
    ? element.options["logo-style"]
    : variant.options["logo-style"]
    ? variant.options["logo-style"]
    : "dark";

  const logoSource =
    logoFormat == "image" && logoStyle == "custom"
      ? element.options["logo-image"] ||
        variant.options["logo-image"] ||
        DEFAULT_CUSTOM_LOGO_URL
      : logoFormat == "image" && website.data[`logo-${logoStyle}`]
      ? website.data[`logo-${logoStyle}`]
      : logoStyle == "dark"
      ? DEFAULT_CUSTOM_LOGO_URL
      : logoStyle == "light"
      ? DEFAULT_LIGHT_LOGO_URL
      : website.data["logo-dark"];

  const logoIconSource =
    logoFormat == "icon" &&
    logoStyle == "custom" &&
    element.options["logo-image"]
      ? element.options["logo-image"]
      : logoFormat == "icon" &&
        logoStyle == "custom" &&
        variant.options["logo-image"]
      ? variant.options["logo-image"]
      : website.data[`logo-icon-${logoStyle}`]
      ? website.data[`logo-icon-${logoStyle}`]
      : logoStyle == "dark"
      ? "https://uploads.convertflow.co/production/websites/417/QI2ycrYmQIK5feEeq9J1_brand-logo-icon-dark.webp"
      : logoStyle == "light"
      ? "https://uploads.convertflow.co/production/websites/417/NESckLYPTVlOJGWTnzqs_brand-logo-icon-light.webp"
      : website.data["logo-icon-dark"];

  const altText = element.options["alt-text"]
    ? element.options["alt-text"]
    : variant.options["logo-alt-text"]
    ? variant.options["logo-alt-text"]
    : "";

  const logoLink = normalizeUrl(
    element.options["logo-link"]
      ? element.options["logo-link"]
      : variant.options["logo-link"]
      ? variant.options["logo-link"]
      : website.data["logo-link"]
  );
  const logoLinkNewTabValue = element.options["logo-link-new-tab"]
    ? element.options["logo-link-new-tab"]
    : variant.options["logo-link-new-tab"]
    ? variant.options["logo-link-new-tab"]
    : null;
  const logoLinkNewTab = ["true", "on"].includes(logoLinkNewTabValue);

  const hamburgerEnabled =
    (element.options["nav-hamburger"] ||
      variant.options["nav-hamburger"] ||
      "true") !== "false";
  const [menuOpen, setMenuOpen] = useState(false);

  const selectedNavId = element.options["website-navigation-id"];
  const websiteNavigations = {
    ...(website.navigations || {}),
  };
  if (element.website_navigation && element.website_navigation.id) {
    websiteNavigations[element.website_navigation.id] =
      websiteNavigations[element.website_navigation.id] ||
      element.website_navigation;
  }
  const selectedNavigation = selectedNavId
    ? websiteNavigations[selectedNavId] ||
      websiteNavigations[String(selectedNavId)]
    : null;
  const websiteNavLinks = Object.values(selectedNavigation?.links || {})
    .filter((link) => link.toBeDeleted !== true)
    .sort((a, b) => a.position - b.position);

  // Website navigations are the source of truth from website metadata. Only
  // fall back to element content_list_items when no navigation is selected.
  const sorted_links = selectedNavigation
    ? websiteNavLinks
    : Object.values(element.content_list_items || {})
        .filter(
          (list_item) =>
            list_item.element_id == element.id && list_item.toBeDeleted !== true
        )
        .sort((a, b) => a.position - b.position);

  const custom_content_items = Object.values(element.content_toggle_items || {})
    .filter(
      (item) => item.element_id == element.id && item.toBeDeleted !== true
    )
    .filter((item) => (item.options && item.options["show"]) !== "false")
    .sort((a, b) => a.position - b.position);

  const linkLabel = (list_item) => {
    return (list_item.content || "").replace(/<[^>]*>/g, "");
  };

  const linkUrl = (list_item) => {
    return normalizeUrl(
      list_item.url || (list_item.options && list_item.options["link-url"])
    );
  };

  const linkNewTab = (list_item) => {
    if (list_item.new_tab === true || list_item.new_tab === "true") {
      return true;
    }

    return list_item.options && list_item.options["link-new-tab"] == "true";
  };

  return (
    <React.Fragment>
      <div
        id={"element" + element.id + "-content"}
        className={`element-content cf-navigation${
          menuOpen ? " cf-navigation-open" : ""
        }`}
      >
        <div className="cf-navigation-bar">
          {logoShow && (
            <div className="cf-navigation-logo">
              <a
                className="cf-logo-link"
                href={props.builder !== true ? logoLink : "#"}
                target={
                  props.builder !== true &&
                  logoLink &&
                  logoLink !== "#" &&
                  logoLinkNewTab
                    ? "_blank"
                    : "_self"
                }
                rel={
                  props.builder !== true &&
                  logoLink &&
                  logoLink !== "#" &&
                  logoLinkNewTab
                    ? "noopener noreferrer"
                    : undefined
                }
                onClick={(e) => {
                  if (props.builder == true) {
                    e.preventDefault();
                  }
                }}
              >
                {logoFormat == "image" && (
                  <img
                    loading="lazy"
                    data-format="image"
                    data-style={logoStyle}
                    src={logoSource}
                    alt={altText}
                  />
                )}
                {logoFormat == "icon" && (
                  <img
                    loading="lazy"
                    data-format="icon"
                    data-style={logoStyle}
                    src={logoIconSource}
                    alt={altText}
                  />
                )}
              </a>
            </div>
          )}

          {hamburgerEnabled && (
            <button
              className="cf-navigation-hamburger"
              type="button"
              aria-label="Toggle navigation menu"
              aria-expanded={menuOpen ? "true" : "false"}
              onClick={(e) => {
                if (props.builder == true) {
                  e.preventDefault();
                  setMenuOpen((open) => !open);
                }
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          )}

          <div className="cf-navigation-menu">
            <ul className="cf-navigation-links">
              {sorted_links.map((list_item) => {
                return (
                  <li
                    key={"nav-link-" + list_item.id}
                    id={`nav-link-${list_item.id}`}
                    className="cf-navigation-link"
                    data-object-id={list_item.id}
                  >
                    <a
                      href={props.builder !== true ? linkUrl(list_item) : "#"}
                      target={
                        props.builder !== true && linkNewTab(list_item)
                          ? "_blank"
                          : "_self"
                      }
                      rel={
                        props.builder !== true && linkNewTab(list_item)
                          ? "noopener noreferrer"
                          : undefined
                      }
                      onClick={(e) => {
                        if (props.builder == true) {
                          e.preventDefault();
                        }
                      }}
                    >
                      {linkLabel(list_item)}
                    </a>
                  </li>
                );
              })}
            </ul>

            {custom_content_items.length > 0 && (
              <div className="cf-navigation-custom">
                {custom_content_items.map((item) => {
                  const toggle_item_section = Object.values(
                    element.sections || {}
                  ).find(
                    (section) => section.content_toggle_item_id == item.id
                  );

                  if (!toggle_item_section) {
                    return null;
                  }

                  return (
                    <div
                      className="cf-navigation-custom-element"
                      data-content-toggle-item-id={item.id}
                      key={"nav-custom-" + item.id}
                    >
                      <Section
                        website={props.website}
                        cta={props.cta}
                        variant={props.variant}
                        builder={props.builder}
                        preview={props.preview}
                        step={props.step}
                        section={toggle_item_section}
                        device={props.device}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
      </div>
    </React.Fragment>
  );
};

const style = {
  stylesheet: (builder, device, cta, element, variant) => {
    let options = { ...element.options };

    const themed = (key, fallback = undefined) => {
      return options[key] || variant.options[key] || fallback;
    };

    const navLayout = options["nav-layout"] || "links-right";
    const navWidth = options["nav-width"];
    const navWidthMobile = options["nav-width-mobile"];
    const navSpacing = isValuePresent(options["nav-spacing"])
      ? options["nav-spacing"]
      : 15;
    const navSpacingMobile = options["nav-spacing-mobile"];
    const linksLayout = themed("nav-links-layout", "horizontal");

    const alignmentMargins = (alignment) =>
      alignment && alignment.indexOf("left") > -1
        ? "margin-left: 0 !important; margin-right: auto !important;"
        : alignment && alignment.indexOf("right") > -1
        ? "margin-left: auto !important; margin-right: 0 !important;"
        : "margin-left: auto !important; margin-right: auto !important;";

    const navBackgroundColor = themed("nav-background-color");

    const navBorderStyle = themed("nav-border-style");
    const navBorderColor = themed("nav-border-color", "#000");

    const navBorderWidthLeft =
      _.isNil(options["nav-border-width-left"]) == false
        ? options["nav-border-width-left"]
        : variant.options["nav-border-width-left"];
    const navBorderWidthRight =
      _.isNil(options["nav-border-width-right"]) == false
        ? options["nav-border-width-right"]
        : variant.options["nav-border-width-right"];
    const navBorderWidthTop =
      _.isNil(options["nav-border-width-top"]) == false
        ? options["nav-border-width-top"]
        : variant.options["nav-border-width-top"];
    const navBorderWidthBottom =
      _.isNil(options["nav-border-width-bottom"]) == false
        ? options["nav-border-width-bottom"]
        : variant.options["nav-border-width-bottom"];

    const navBorderRadiusSetting = themed("nav-border-radius");
    let navBorderRadius = "";
    if (navBorderRadiusSetting == "cf-not-rounded") {
      navBorderRadius = "0px";
    }
    if (navBorderRadiusSetting == "cf-slightly-rounded") {
      navBorderRadius = "4px";
    }
    if (navBorderRadiusSetting == "cf-fully-rounded") {
      navBorderRadius = "100px";
    }
    if (navBorderRadiusSetting == "custom") {
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          navBorderRadius += `${
            _.isNil(options["nav-border-radius-" + side]) == false
              ? options["nav-border-radius-" + side]
              : _.isNil(variant.options["nav-border-radius-" + side]) == false
              ? variant.options["nav-border-radius-" + side]
              : "0"
          }px `;
        }
      );
      navBorderRadius = navBorderRadius.trim();
    }

    const linksFontFamily = themed("nav-links-font-family");
    const linksFontWeight = themed("nav-links-font-weight");
    const linksFontSize = themed("nav-links-font-size");
    const linksFontColor = themed("nav-links-font-color");
    const linksHoverColor = themed("nav-links-hover-color");
    const linksSpacing = themed("nav-links-spacing", 25);

    const hamburgerEnabled = themed("nav-hamburger", "true") !== "false";
    const hamburgerColor = themed("nav-hamburger-color", "#000");
    const menuBackgroundColor = themed("nav-menu-background-color");
    const menuPadding = isValuePresent(options["nav-menu-padding"])
      ? options["nav-menu-padding"]
      : isValuePresent(variant.options["nav-menu-padding"])
      ? variant.options["nav-menu-padding"]
      : 10;
    const menuBorderStyle = themed("nav-menu-border-style");
    const menuBorderColor = themed("nav-menu-border-color", "#000");
    const menuBorderWidthLeft =
      _.isNil(options["nav-menu-border-width-left"]) == false
        ? options["nav-menu-border-width-left"]
        : variant.options["nav-menu-border-width-left"];
    const menuBorderWidthRight =
      _.isNil(options["nav-menu-border-width-right"]) == false
        ? options["nav-menu-border-width-right"]
        : variant.options["nav-menu-border-width-right"];
    const menuBorderWidthTop =
      _.isNil(options["nav-menu-border-width-top"]) == false
        ? options["nav-menu-border-width-top"]
        : variant.options["nav-menu-border-width-top"];
    const menuBorderWidthBottom =
      _.isNil(options["nav-menu-border-width-bottom"]) == false
        ? options["nav-menu-border-width-bottom"]
        : variant.options["nav-menu-border-width-bottom"];

    const menuBorderRadiusSetting = themed("nav-menu-border-radius");
    let menuBorderRadius = "";
    if (menuBorderRadiusSetting == "cf-not-rounded") {
      menuBorderRadius = "0px";
    }
    if (menuBorderRadiusSetting == "cf-slightly-rounded") {
      menuBorderRadius = "4px";
    }
    if (menuBorderRadiusSetting == "cf-fully-rounded") {
      menuBorderRadius = "100px";
    }
    if (menuBorderRadiusSetting == "custom") {
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          menuBorderRadius += `${
            _.isNil(options["nav-menu-border-radius-" + side]) == false
              ? options["nav-menu-border-radius-" + side]
              : _.isNil(variant.options["nav-menu-border-radius-" + side]) ==
                false
              ? variant.options["nav-menu-border-radius-" + side]
              : "0"
          }px `;
        }
      );
      menuBorderRadius = menuBorderRadius.trim();
    }

    const menuShadowSetting = themed("nav-menu-shadow");
    let menuBoxShadow;
    if (menuShadowSetting == "None") {
      menuBoxShadow = "none";
    }
    if (menuShadowSetting == "soft") {
      menuBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }
    if (menuShadowSetting == "hard") {
      menuBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }
    if (menuShadowSetting == "custom") {
      menuBoxShadow = [
        `${
          options["nav-menu-shadow-horizontal-distance"] ||
          variant.options["nav-menu-shadow-horizontal-distance"] ||
          "0"
        }px`,
        `${
          options["nav-menu-shadow-vertical-distance"] ||
          variant.options["nav-menu-shadow-vertical-distance"] ||
          "0"
        }px`,
        `${
          options["nav-menu-shadow-blur-radius"] ||
          variant.options["nav-menu-shadow-blur-radius"] ||
          "0"
        }px`,
        `${
          options["nav-menu-shadow-spread-radius"] ||
          variant.options["nav-menu-shadow-spread-radius"] ||
          "0"
        }px`,
        options["nav-menu-shadow-color"] ||
          variant.options["nav-menu-shadow-color"] ||
          "rgba(0,0,0, 0.35)",
        (options["nav-menu-shadow-inset"] ||
          variant.options["nav-menu-shadow-inset"]) == "true"
          ? "inset"
          : "",
      ]
        .join(" ")
        .trim();
    }

    const controlStyle = options["control-style"]
      ? options["control-style"]
      : "width";
    const logoWidth =
      options["image-width"] ||
      variant.options["logo-image-width"] ||
      (controlStyle == "width" ? 150 : undefined);
    const logoHeight =
      options["image-height"] || variant.options["logo-image-height"];

    const customOnLeft = navLayout == "custom-left";
    const customOnCenter = navLayout == "custom-center";
    const customOnRight =
      navLayout == "custom-right" || navLayout == "links-right";
    const linksCenterCustomRight = navLayout == "links-center-custom-right";
    const linksCenterCustomLeft = navLayout == "links-center-custom-left";
    const linksLeftCustomRight = navLayout == "links-left-custom-right";
    const linksLeftCustomCenter = navLayout == "links-left-custom-center";
    const linksLeftCustomLeft = navLayout == "links-left-custom-left";

    const layoutStyles =
      navLayout == "stacked"
        ? `flex-direction: column !important; justify-content: center !important;`
        : `flex-direction: row !important; justify-content: flex-start !important;`;

    const menuLayoutStyles = [
      customOnLeft || customOnRight
        ? "margin-left: auto !important;"
        : navLayout == "links-center" ||
          linksCenterCustomRight ||
          linksCenterCustomLeft
        ? "flex: 1 1 auto !important; justify-content: center !important;"
        : "",
      customOnRight || linksCenterCustomRight || linksLeftCustomRight
        ? "order: 2 !important;"
        : customOnLeft ||
          customOnCenter ||
          linksCenterCustomLeft ||
          linksLeftCustomLeft
        ? "order: 3 !important;"
        : linksLeftCustomCenter
        ? "order: 2 !important;"
        : "",
    ]
      .filter(Boolean)
      .join(" ");

    const customLayoutStyles = [
      "display: flex !important;",
      "align-items: center !important;",
      "flex-wrap: wrap !important;",
      `column-gap: ${linksSpacing}px !important;`,
      "row-gap: 10px !important;",
      "min-width: 0 !important;",
      customOnLeft ||
      customOnCenter ||
      linksCenterCustomLeft ||
      linksLeftCustomLeft
        ? "order: 2 !important;"
        : customOnRight ||
          linksCenterCustomRight ||
          linksLeftCustomRight ||
          linksLeftCustomCenter
        ? "order: 3 !important;"
        : "",
      customOnCenter || linksLeftCustomCenter
        ? "flex: 1 1 auto !important; justify-content: center !important;"
        : linksLeftCustomRight
        ? "margin-left: auto !important;"
        : "",
    ]
      .filter(Boolean)
      .join(" ");

    const verticalLinksAlignment =
      navLayout == "stacked" ||
      navLayout == "links-center" ||
      linksCenterCustomRight ||
      linksCenterCustomLeft
        ? "center"
        : navLayout == "links-left" ||
          linksLeftCustomRight ||
          linksLeftCustomCenter ||
          linksLeftCustomLeft
        ? "flex-start"
        : "flex-end";

    // prettier-ignore
    const desktopStyles =
      `${navWidth ? `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation {
        width: ${navWidth}px !important;
        max-width: 100% !important;
        ${alignmentMargins(options["cf-alignment"])}
      }` : ''}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-bar {
        display: flex !important;
        align-items: center !important;
        flex-wrap: wrap !important;
        width: 100% !important;
        box-sizing: border-box !important;
        column-gap: 20px !important;
        padding: ${navSpacing}px !important;
        ${layoutStyles}
        ${navBackgroundColor ? `background: ${navBackgroundColor} !important;` : ''}
        ${navBorderStyle ? `border-style: ${navBorderStyle} !important;` : ''}
        ${navBorderStyle && navBorderStyle !== "none" ? `border-color: ${navBorderColor} !important;` : ''}
        ${_.isNil(navBorderWidthLeft) == false ? `border-left-width: ${navBorderWidthLeft}px !important;` : ''}
        ${_.isNil(navBorderWidthRight) == false ? `border-right-width: ${navBorderWidthRight}px !important;` : ''}
        ${_.isNil(navBorderWidthTop) == false ? `border-top-width: ${navBorderWidthTop}px !important;` : ''}
        ${_.isNil(navBorderWidthBottom) == false ? `border-bottom-width: ${navBorderWidthBottom}px !important;` : ''}
        ${navBorderRadius ? `border-radius: ${navBorderRadius} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-logo {
        min-width: 0 !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-logo img {
        display: block !important;
        max-width: 100% !important;
        ${controlStyle == "width" && logoWidth ? `width: ${logoWidth}px !important; height: auto !important;` : ''}
        ${controlStyle == "height" && logoHeight ? `height: ${logoHeight}px !important; width: auto !important; object-fit: contain !important;` : ''}
        ${!logoWidth && !logoHeight ? 'max-height: 50px !important; width: auto !important; height: auto !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-menu {
        display: contents !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-custom {
        ${customLayoutStyles}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-links {
        display: flex !important;
        ${linksLayout == "vertical" ? 'flex-direction: column !important;' : ''}
        align-items: ${linksLayout == "vertical" ? verticalLinksAlignment : "center"} !important;
        flex-wrap: wrap !important;
        column-gap: ${linksSpacing}px !important;
        row-gap: ${linksLayout == "vertical" ? linksSpacing : 10}px !important;
        list-style: none !important;
        margin: 0 !important;
        padding: 0 !important;
        ${menuLayoutStyles}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-link {
        list-style: none !important;
        width: auto !important;
        max-width: none !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-link a {
        display: block !important;
        text-decoration: none !important;
        cursor: pointer !important;
        ${linksFontFamily ? `font-family: ${linksFontFamily}, sans-serif !important;` : ''}
        ${linksFontWeight ? `font-weight: ${linksFontWeight} !important;` : ''}
        ${linksFontSize ? `font-size: ${linksFontSize}px !important;` : 'font-size: 16px !important;'}
        ${linksFontColor ? `color: ${linksFontColor} !important;` : 'color: #000 !important;'}
      }

      ${linksHoverColor ? `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-link a:hover {
        color: ${linksHoverColor} !important;
      }` : ''}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-hamburger {
        display: none !important;
        width: auto !important;
        flex-shrink: 0 !important;
        background: transparent !important;
        border: none !important;
        padding: 5px !important;
        margin-left: auto !important;
        cursor: pointer !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-hamburger span {
        display: block !important;
        width: 22px !important;
        height: 2px !important;
        margin: 4px 0 !important;
        background: ${hamburgerColor} !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-custom-element,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-custom-element > .cf-section,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-navigation-custom-element > .cf-section > .cf-section-container {
        min-width: 0 !important;
        max-width: 100% !important;
      }
      `;

    const linksFontSizeMobile = options["nav-links-font-size-mobile"]
      ? options["nav-links-font-size-mobile"]
      : variant.options["nav-links-font-size-mobile"]
      ? variant.options["nav-links-font-size-mobile"]
      : linksFontSize;

    const linksSpacingMobile = options["nav-links-spacing-mobile"]
      ? options["nav-links-spacing-mobile"]
      : variant.options["nav-links-spacing-mobile"]
      ? variant.options["nav-links-spacing-mobile"]
      : linksSpacing;

    const controlStyleMobile = options["control-style-mobile"]
      ? options["control-style-mobile"]
      : controlStyle;
    const logoWidthMobile =
      options["image-width-mobile"] ||
      variant.options["logo-image-width-mobile"];
    const logoHeightMobile =
      options["image-height-mobile"] ||
      variant.options["logo-image-height-mobile"];

    const selector = `#cta_${cta.id} .cf-element[data-element-id="${element.id}"]`;
    // prettier-ignore
    const mobileMenuStyles = hamburgerEnabled
      ? `${selector} .cf-navigation-hamburger {
        display: block !important;
        order: 3 !important;
      }

      ${navLayout == "stacked" ? `${selector} .cf-navigation-bar {
        flex-direction: row !important;
      }

      ${selector} .cf-navigation-logo {
        display: flex !important;
        justify-content: center !important;
      }

      ${selector} .cf-navigation-links {
        justify-content: center !important;
      }` : ""}

      ${selector} .cf-navigation-menu {
        display: none !important;
        flex-direction: column !important;
        align-items: stretch !important;
        flex: 1 1 100% !important;
        min-width: 0 !important;
        width: 100% !important;
        box-sizing: border-box !important;
        margin-left: 0 !important;
        order: 4 !important;
        padding: ${menuPadding}px !important;
        row-gap: ${linksSpacingMobile}px !important;
        ${menuBackgroundColor ? `background: ${menuBackgroundColor} !important;` : ""}
        ${menuBorderStyle ? `border-style: ${menuBorderStyle} !important;` : ""}
        ${menuBorderStyle && menuBorderStyle !== "none" ? `border-color: ${menuBorderColor} !important;` : ""}
        ${_.isNil(menuBorderWidthLeft) == false ? `border-left-width: ${menuBorderWidthLeft}px !important;` : ""}
        ${_.isNil(menuBorderWidthRight) == false ? `border-right-width: ${menuBorderWidthRight}px !important;` : ""}
        ${_.isNil(menuBorderWidthTop) == false ? `border-top-width: ${menuBorderWidthTop}px !important;` : ""}
        ${_.isNil(menuBorderWidthBottom) == false ? `border-bottom-width: ${menuBorderWidthBottom}px !important;` : ""}
        ${menuBorderRadius ? `border-radius: ${menuBorderRadius} !important;` : ""}
        ${menuBoxShadow ? `box-shadow: ${menuBoxShadow} !important;` : ""}
      }

      ${selector} .cf-navigation.cf-navigation-open .cf-navigation-menu {
        display: flex !important;
      }

      ${selector} .cf-navigation-custom {
        order: 0 !important;
        flex: none !important;
        width: 100% !important;
        justify-content: flex-start !important;
      }

      ${selector} .cf-navigation-custom-element {
        width: 100% !important;
      }

      ${selector} .cf-navigation-links {
        display: flex !important;
        flex-direction: column !important;
        align-items: ${navLayout == "stacked" ? "center" : "flex-start"} !important;
        row-gap: ${linksSpacingMobile}px !important;
        width: 100% !important;
        margin-left: 0 !important;
        order: 0 !important;
        flex: none !important;
      }`
      : `${selector} .cf-navigation-menu {
        display: contents !important;
        column-gap: ${linksSpacingMobile}px !important;
      }

      ${selector} .cf-navigation-links {
        column-gap: ${linksSpacingMobile}px !important;
      }`;

    // prettier-ignore
    const mobileStyles =
      `/* mobile styles */
      ${navWidthMobile || (navWidth && options["cf-alignment-mobile"]) ? `${selector} .cf-navigation {
        ${navWidthMobile ? `width: ${navWidthMobile}px !important;
        max-width: 100% !important;` : ""}
        ${alignmentMargins(options["cf-alignment-mobile"] || options["cf-alignment"])}
      }` : ""}

      ${isValuePresent(navSpacingMobile) ? `${selector} .cf-navigation-bar {
        padding: ${navSpacingMobile}px !important;
      }` : ""}

      ${selector} .cf-navigation-logo img {
        ${controlStyleMobile == "width" && logoWidthMobile ? `width: ${logoWidthMobile}px !important; height: auto !important;` : ""}
        ${controlStyleMobile == "height" && logoHeightMobile ? `height: ${logoHeightMobile}px !important; width: auto !important; max-width: 100% !important; object-fit: contain !important;` : ""}
      }

      ${selector} .cf-navigation-link a {
        ${linksFontSizeMobile ? `font-size: ${linksFontSizeMobile}px !important;` : ""}
      }

      ${mobileMenuStyles}
      `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
  },
};

export default ElementNavigation;
